// @flow

import isNil from 'lodash.isnil';
import {CONTENT_TYPE_KEY, CONTENT_TYPE_FORM_DATA} from '../constants';
import type {Headers, RequestParams} from '../typedef';


const prepareRequestQuery = (data: RequestParams) => {
    let entries = '';
    const keys = Object.keys(data);
    if (keys.length) {
        const valuesList = [];
        for (let index = 0; index < keys.length; index++) {  
            const keyValue = keys[index];
            const value = data[keyValue];
            if (!isNil(value)) {
                valuesList.push(`${encodeURIComponent(keyValue)}=${encodeURIComponent(value)}`);
            }
        }
        entries = valuesList.join('&');
    }
    return entries;
};

type PrepareBodyParams = (data: { headers: Headers, params: RequestParams }) => {
    headers: Headers,
    body: string,
};

export const prepareBodyParams: PrepareBodyParams = ({headers, params}) => ({
    headers: {
        ...headers,
        [CONTENT_TYPE_KEY]: headers[CONTENT_TYPE_KEY] || CONTENT_TYPE_FORM_DATA
    },
    body: prepareRequestQuery(params)
});

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
